var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"clearfix mb-0"},[_c('span',{staticClass:"float-md-right d-none d-md-block"},[_vm._v("VISÃO ALPHA COORDENAÇÃO DE VENDAS ")])])}]

export { render, staticRenderFns }